// src/components/MealForm.js

import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

const MealForm = ({ open, onClose, onSubmit, meal }) => {
  // If editing, initialize with meal data; otherwise, use defaults.
  const [dayOfWeek, setDayOfWeek] = useState(meal ? meal.day_of_week : 1);
  const [description, setDescription] = useState(meal ? meal.description : '');

  useEffect(() => {
    if (meal) {
      setDayOfWeek(meal.day_of_week);
      setDescription(meal.description);
    } else {
      setDayOfWeek(1);
      setDescription('');
    }
  }, [meal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ day_of_week: dayOfWeek, description });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{meal ? 'Editare Masa' : 'Creare Masa'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {/* Wrap content in a Box with a fixed maxHeight to mitigate ResizeObserver warnings */}
          <Box sx={{ maxHeight: '80vh', overflowY: 'auto' }}>
              <FormControl fullWidth margin="normal">
              <InputLabel id="day-of-week-label">Ziua</InputLabel>
              <Select
                labelId="day-of-week-label"
                value={dayOfWeek}
                onChange={(e) => setDayOfWeek(e.target.value)}
                required
              >
                <MenuItem value={1}>Luni</MenuItem>
                <MenuItem value={2}>Marți</MenuItem>
                <MenuItem value={3}>Miercuri</MenuItem>
                <MenuItem value={4}>Joi</MenuItem>
                <MenuItem value={5}>Vineri</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Descrierea"
              fullWidth
              margin="normal"
              multiline
              rows={20}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="secondary">Înapoi</Button>
          <Button variant="contained" color="primary" type="submit">
            {meal ? 'Editează' : 'Crează'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MealForm;
